import { createContext, useContext } from 'react';

const ProjectContext = createContext({
  addNewProject: () => {},
  duplicateActiveProject: () => {},
  handleEditTabName: () => {},
});

export const useProjectContext = () => useContext(ProjectContext);

export default ProjectContext;
